export enum Domain {
  LARA = "lara.law",
  LODA = "loda.dk",
}

export function getDomain(hostname?: string): Domain | null {
  if (!hostname) return null;
  const host = hostname.toLowerCase();

  if (host === Domain.LARA || host.endsWith("." + Domain.LARA)) {
    return Domain.LARA;
  }
  if (host === Domain.LODA || host.endsWith("." + Domain.LODA)) {
    return Domain.LODA;
  }

  return null;
}

export const getDomainName = (domain: Domain | null) => {
  switch (domain) {
    case Domain.LARA:
      return "Lara";
    case Domain.LODA:
      return "Loda";
    default:
      return "Lara";
  }
};

export const buildDocumentLinkUrl = (guid: string): string => {
  const hostname = window.location.hostname.toLowerCase();
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  if (!isLocalhost) {
    return `${window.location.origin}/docLink/${guid}`;
  }

  // Fallback to dev.app.lara.law if localhost
  return `https://dev.app.lara.law/docLink/${guid}`;
};
